import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 12px 0;
  background-color: var(--portal-primary);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  position: fixed;
  z-index: 1001;
  width: 100%;
  top: 0px;

  @media(max-width: 1280px) {
    padding: 12px 0;
    width: 100%;
  }

  > div {
    cursor: pointer;
  }

  svg {
    margin-top: 2px;
  }

  a {
    text-decoration: none;
    color: #ffffff;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const EntityNameWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 1024px) {
    gap: 8px;
  }
`;

export const EntityType = styled.span`
  font-size: 12px;
  font-weight: 400;
  opacity: 0.9;
  white-space: nowrap;

  @media (max-width: 1024px) {
    font-size: 11px;
  }
`;

export const EntityName = styled.span`
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;

  @media (max-width: 1280px) {
    font-size: 14px;
    max-width: 300px;
  }

  @media (max-width: 1024px) {
    font-size: 13px;
    max-width: 200px;
  }
`;

export const Divider = styled.div`
  width: 2px;
  height: 24px;
  background-color: rgba(255, 255, 255, 0.3);

  @media (max-width: 1024px) {
    height: 20px;
  }
`;
